
angular.module('bmsApp.crm.customer', [
	'ui.router'
])
	.config([
		'$stateProvider', 'BMSPermission', function config(
			$stateProvider,
			BMSPermission
			) {

			$stateProvider

				.state('main.crm.customer', {
					abstract: true,
					data: {
						authorisedRoles: [BMSPermission.CRM]
					}
				})

				.state('main.crm.customer.index', {
					url: '^/crm/customers',
					views: {
						'content@main.crm': {
							templateUrl: "ng/crm/customer/templates/CustomerIndex.html",
							controller: 'CustomerIndexCtrl'
						},
						'side@main.crm': {
							templateUrl: "ng/crm/customer/templates/CustomerIndexSide.html"
						}
					},
					ncyBreadcrumb: {label: 'Customers'}
				})

				.state('main.crm.customer.index.view', {
					url: '^/crm/customer/{customerId:int}',
					views: {
						'content@main.crm': {
							templateUrl: "ng/crm/customer/templates/view/CustomerView.html",
							controller: 'CustomerViewCtrl'
						}
					},
					ncyBreadcrumb: {label: '{{ customer.display_name }}'}
				})

				.state('main.crm.customer.index.create', {
					url: '^/crm/customer/add',
					views: {
						'content@main.crm': {
							templateUrl: "ng/crm/customer/templates/CustomerSave.html",
							controller: 'CustomerSaveCtrl'
						}
					},
					ncyBreadcrumb: {label: 'Add Customer'}
				})

				.state('main.crm.enquiry.index.view.convert', {
					url: '^/crm/enquiry/convert/{enquiryId:int}',
					views: {
						'content@main.crm': {
							templateUrl: "ng/crm/customer/templates/CustomerSave.html",
							controller: 'CustomerSaveCtrl'
						}
					},
					ncyBreadcrumb: {label: 'Convert to Customer'}
				})

				.state('main.crm.customer.index.view.update', {
					url: '^/crm/customer/edit/{customerId:int}',
					views: {
						'content@main.crm': {
							templateUrl: "ng/crm/customer/templates/CustomerSave.html",
							controller: 'CustomerSaveCtrl'
						}
					},
					ncyBreadcrumb: {label: 'Edit Customer'}
				})

				.state('main.crm.customer.index.import', {
					url: '^/crm/customers/import',
					views: {
						'content@main.crm': {
							templateUrl: "ng/crm/customer/templates/CustomerImport.html",
							controller: 'CustomerImportCtrl'
						}
					},
					ncyBreadcrumb: {label: 'Import Customers'}
				})

				.state('main.crm.customer.index.mapMultiple', {
					url: '^/crm/customers/map/:params',
					views: {
						'main@main': {
							templateUrl: "ng/crm/customer/templates/CustomerMap.html",
							controller: 'CustomerMapCtrl'
						}
					},
					ncyBreadcrumb: {label: 'Customers'}
				})

				.state('main.crm.customer.index.mapSingle', {
					url: '^/crm/customers/map/id/:id',
					views: {
						'main@main': {
							templateUrl: "ng/crm/customer/templates/CustomerMap.html",
							controller: 'CustomerMapCtrl'
						}
					},
					ncyBreadcrumb: {label: 'Customers'}
				})

				.state('main.crm.customer.index.mapActiveJobs', {
					url: '^/crm/customers/active-jobs-maps',
					views: {
						'main@main': {
							templateUrl: "ng/crm/customer/templates/CustomerMap.html",
							controller: 'CustomerMapActiveJobsCtrl'
						}
					},
					ncyBreadcrumb: {label: 'Customers (Active Jobs)'}
				})

				;

		}]);
